import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { useCallback, useState } from "react";
import Menu from "@mui/material/Menu";
import { useStyles } from "./styles";
import { map } from "lodash";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import { Button } from "@mui/material";

type IconButtonMenuProps = IconButtonProps & {
  onClick?: () => void;
  options: {
    icon?: string;
    label: string;
    title?: string;
    description?: string;
    onClick?: () => void;
  }[];
};

export function NewIconButtonMenu({
  options,
  onClick,
  ...rest
}: IconButtonMenuProps) {
  const [user] = useState(JSON.parse(localStorage.getItem("@datasales:user")!));

  console.log(user);

  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickOption = useCallback((_: any) => {
    _?.onClick();
    handleClose();
  }, []);
  return (
    <>
      <IconButton
        {...rest}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {rest.children}
      </IconButton>
      <Menu
        keepMounted
        classes={{ root: styles.root, paper: styles.paper }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {map(options, (option, index) => (
          <>
            <MenuItem style={{ padding: 12 }} key={index.toString()}>
              <div>
                {option?.title && (
                  <ListItemText
                    primary={option.title}
                    classes={{ primary: styles.font }}
                  />
                )}
                <div
                  onClick={() => {
                    handleClickOption(option);
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <Avatar
                    id="avatar"
                    className={styles.icon}
                    src={option.icon}
                    sx={{ width: 20, height: 20 }}
                    variant="rounded"
                  />
                  <ListItemText
                    primary={option.label}
                    classes={{ primary: styles.font }}
                  />
                </div>
              </div>
            </MenuItem>
            {option?.label === "delivery Vip" && !user?.deliveryVip && (
              <Button
                color="secondary"
                style={{
                  width: "90%",
                  height: "36px",
                  backgroundColor: "#2813AD",
                  marginLeft: "5%",
                  marginBottom: "20px",
                  marginTop: "3px",
                  color: "#fff",
                }}
                onClick={onClick}
              >
                cadastrar loja online
              </Button>
            )}
          </>
        ))}
      </Menu>
    </>
  );
}
